import { type TileCoordinates } from "@/types/tile";
import type { FrameName } from "../entities/config";
// Kubo 7
import AlchemistAbandoned1PoiTileEntity from "../entities/poi/AlchemistAbandoned1PoiTileEntity";
import AlchemistAbandoned2PoiTileEntity from "../entities/poi/AlchemistAbandoned2PoiTileEntity";
import AlchemistAbandoned3PoiTileEntity from "../entities/poi/AlchemistAbandoned3PoiTileEntity";
import AlchemistAbandoned4PoiTileEntity from "../entities/poi/AlchemistAbandoned4PoiTileEntity";
import AssassinsHideout1PoiTileEntity from "../entities/poi/AssassinsHideout1PoiTileEntity";
import AssassinsHideout2PoiTileEntity from "../entities/poi/AssassinsHideout2PoiTileEntity";
import AssassinsHideout3PoiTileEntity from "../entities/poi/AssassinsHideout3PoiTileEntity";
import AssassinsHideout4PoiTileEntity from "../entities/poi/AssassinsHideout4PoiTileEntity";
import AstronomerHideout1PoiTileEntity from "../entities/poi/AstronomerHideout1PoiTileEntity";
import AstronomerHideout2PoiTileEntity from "../entities/poi/AstronomerHideout2PoiTileEntity";
import AstronomerHideout3PoiTileEntity from "../entities/poi/AstronomerHideout3PoiTileEntity";
import AstronomerHideout4PoiTileEntity from "../entities/poi/AstronomerHideout4PoiTileEntity";
import Atol1PoiTileEntity from "../entities/poi/Atol1PoiTileEntity";
import Atol2PoiTileEntity from "../entities/poi/Atol2PoiTileEntity";
import Atol3PoiTileEntity from "../entities/poi/Atol3PoiTileEntity";
import Atol4PoiTileEntity from "../entities/poi/Atol4PoiTileEntity";
import Atol5PoiTileEntity from "../entities/poi/Atol5PoiTileEntity";
import Atol6PoiTileEntity from "../entities/poi/Atol6PoiTileEntity";
import Atol7PoiTileEntity from "../entities/poi/Atol7PoiTileEntity";
import Atol8PoiTileEntity from "../entities/poi/Atol8PoiTileEntity";
import Atol9PoiTileEntity from "../entities/poi/Atol9PoiTileEntity";
import BearSkeleton1PoiTileEntity from "../entities/poi/BearSkeleton1PoiTileEntity";
import BigMushroom1PoiTileEntity from "../entities/poi/BigMushroom1PoiTileEntity";
import BigMushroom2PoiTileEntity from "../entities/poi/BigMushroom2PoiTileEntity";
import BigMushroom3PoiTileEntity from "../entities/poi/BigMushroom3PoiTileEntity";
import BigMushroom4PoiTileEntity from "../entities/poi/BigMushroom4PoiTileEntity";
import CampSiege1PoiTileEntity from "../entities/poi/CampSiege1PoiTileEntity";
import CampSiege2PoiTileEntity from "../entities/poi/CampSiege2PoiTileEntity";
import CampSiege3PoiTileEntity from "../entities/poi/CampSiege3PoiTileEntity";
import CampSiege4PoiTileEntity from "../entities/poi/CampSiege4PoiTileEntity";
import CaravanRuins1PoiTileEntity from "../entities/poi/CaravanRuins1PoiTileEntity";
import CaravanRuins2PoiTileEntity from "../entities/poi/CaravanRuins2PoiTileEntity";
import CastawayIsland1PoiTileEntity from "../entities/poi/CastawayIsland1PoiTileEntity";
import CaveShadows1PoiTileEntity from "../entities/poi/CaveShadows1PoiTileEntity";
import Crater1PoiTileEntity from "../entities/poi/Crater1PoiTileEntity";
import Crater2PoiTileEntity from "../entities/poi/Crater2PoiTileEntity";
import Crater3PoiTileEntity from "../entities/poi/Crater3PoiTileEntity";
import Crater4PoiTileEntity from "../entities/poi/Crater4PoiTileEntity";
import CryptNoble1PoiTileEntity from "../entities/poi/CryptNoble1PoiTileEntity";
import CryptNoble2PoiTileEntity from "../entities/poi/CryptNoble2PoiTileEntity";
import FalconersTower1PoiTileEntity from "../entities/poi/FalconersTower1PoiTileEntity";
import FalconersTower2PoiTileEntity from "../entities/poi/FalconersTower2PoiTileEntity";
import ForestWhispering1PoiTileEntity from "../entities/poi/ForestWhispering1PoiTileEntity";
import ForestWhispering2PoiTileEntity from "../entities/poi/ForestWhispering2PoiTileEntity";
import ForestWhispering3PoiTileEntity from "../entities/poi/ForestWhispering3PoiTileEntity";
import ForestWhispering4PoiTileEntity from "../entities/poi/ForestWhispering4PoiTileEntity";
import ForestWhispering5PoiTileEntity from "../entities/poi/ForestWhispering5PoiTileEntity";
import ForestWhispering6PoiTileEntity from "../entities/poi/ForestWhispering6PoiTileEntity";
import ForestWhispering7PoiTileEntity from "../entities/poi/ForestWhispering7PoiTileEntity";
import ForestWhispering8PoiTileEntity from "../entities/poi/ForestWhispering8PoiTileEntity";
import ForestWhispering9PoiTileEntity from "../entities/poi/ForestWhispering9PoiTileEntity";
import FortressSunken1PoiTileEntity from "../entities/poi/FortressSunken1PoiTileEntity";
import FortressSunken2PoiTileEntity from "../entities/poi/FortressSunken2PoiTileEntity";
import FortressSunken3PoiTileEntity from "../entities/poi/FortressSunken3PoiTileEntity";
import FortressSunken4PoiTileEntity from "../entities/poi/FortressSunken4PoiTileEntity";
import Geyser1PoiTileEntity from "../entities/poi/Geyser1PoiTileEntity";
import Geyser2PoiTileEntity from "../entities/poi/Geyser2PoiTileEntity";
import Geyser3PoiTileEntity from "../entities/poi/Geyser3PoiTileEntity";
import Geyser4PoiTileEntity from "../entities/poi/Geyser4PoiTileEntity";
import HillGallows1PoiTileEntity from "../entities/poi/HillGallows1PoiTileEntity";
import KeepDeserted1PoiTileEntity from "../entities/poi/KeepDeserted1PoiTileEntity";
import KeepDeserted2PoiTileEntity from "../entities/poi/KeepDeserted2PoiTileEntity";
import KeepDeserted3PoiTileEntity from "../entities/poi/KeepDeserted3PoiTileEntity";
import KeepDeserted4PoiTileEntity from "../entities/poi/KeepDeserted4PoiTileEntity";
import Kraken1PoiTileEntity from "../entities/poi/Kraken1PoiTileEntity";
import Kraken2PoiTileEntity from "../entities/poi/Kraken2PoiTileEntity";
import Kraken3PoiTileEntity from "../entities/poi/Kraken3PoiTileEntity";
import Kraken4PoiTileEntity from "../entities/poi/Kraken4PoiTileEntity";
import Menhir1PoiTileEntity from "../entities/poi/Menhir1PoiTileEntity";
import Menhir2PoiTileEntity from "../entities/poi/Menhir2PoiTileEntity";
import MobyDick1PoiTileEntity from "../entities/poi/MobyDick1PoiTileEntity";
import MobyDick2PoiTileEntity from "../entities/poi/MobyDick2PoiTileEntity";
import MobyDick3PoiTileEntity from "../entities/poi/MobyDick3PoiTileEntity";
import MobyDick4PoiTileEntity from "../entities/poi/MobyDick4PoiTileEntity";
import MonasteryAbandoned1PoiTileEntity from "../entities/poi/MonasteryAbandoned1PoiTileEntity";
import MonasteryAbandoned2PoiTileEntity from "../entities/poi/MonasteryAbandoned2PoiTileEntity";
import MonasteryAbandoned3PoiTileEntity from "../entities/poi/MonasteryAbandoned3PoiTileEntity";
import MonasteryAbandoned4PoiTileEntity from "../entities/poi/MonasteryAbandoned4PoiTileEntity";
import MonumentMegalithic1PoiTileEntity from "../entities/poi/MonumentMegalithic1PoiTileEntity";
import MonumentMegalithic2PoiTileEntity from "../entities/poi/MonumentMegalithic2PoiTileEntity";
import MonumentMegalithic3PoiTileEntity from "../entities/poi/MonumentMegalithic3PoiTileEntity";
import MonumentMegalithic4PoiTileEntity from "../entities/poi/MonumentMegalithic4PoiTileEntity";
import MountainLake1PoiTileEntity from "../entities/poi/MountainLake1PoiTileEntity";
import MountainLake2PoiTileEntity from "../entities/poi/MountainLake2PoiTileEntity";
import MountainLake3PoiTileEntity from "../entities/poi/MountainLake3PoiTileEntity";
import MountainLake4PoiTileEntity from "../entities/poi/MountainLake4PoiTileEntity";
import OutpostSea1PoiTileEntity from "../entities/poi/OutpostSea1PoiTileEntity";
import OutpostSea2PoiTileEntity from "../entities/poi/OutpostSea2PoiTileEntity";
import OutpostSea3PoiTileEntity from "../entities/poi/OutpostSea3PoiTileEntity";
import OutpostSea4PoiTileEntity from "../entities/poi/OutpostSea4PoiTileEntity";
import PartlyDemolishedInn1Poi1TileEntity from "../entities/poi/PartlyDemolishedInn1PoiTileEntity";
import PiratesHideout1PoiTileEntity from "../entities/poi/PiratesHideout1PoiTileEntity";
import PiratesHideout2PoiTileEntity from "../entities/poi/PiratesHideout2PoiTileEntity";
import PiratesHideout3PoiTileEntity from "../entities/poi/PiratesHideout3PoiTileEntity";
import PiratesHideout4PoiTileEntity from "../entities/poi/PiratesHideout4PoiTileEntity";
import PiratesHideout5PoiTileEntity from "../entities/poi/PiratesHideout5PoiTileEntity";
import PiratesHideout6PoiTileEntity from "../entities/poi/PiratesHideout6PoiTileEntity";
import PiratesHideout7PoiTileEntity from "../entities/poi/PiratesHideout7PoiTileEntity";
import PiratesHideout8PoiTileEntity from "../entities/poi/PiratesHideout8PoiTileEntity";
import PiratesHideout9PoiTileEntity from "../entities/poi/PiratesHideout9PoiTileEntity";
import PlaguedForest1PoiTileEntity from "../entities/poi/PlaguedForest1PoiTileEntity";
import PlaguedForest2PoiTileEntity from "../entities/poi/PlaguedForest2PoiTileEntity";
import PlaguedForest3PoiTileEntity from "../entities/poi/PlaguedForest3PoiTileEntity";
import PlaguedForest4PoiTileEntity from "../entities/poi/PlaguedForest4PoiTileEntity";
import QuarryFlooded1PoiTileEntity from "../entities/poi/QuarryFlooded1PoiTileEntity";
import QuarryFlooded2PoiTileEntity from "../entities/poi/QuarryFlooded2PoiTileEntity";
import QuarryFlooded3PoiTileEntity from "../entities/poi/QuarryFlooded3PoiTileEntity";
import QuarryFlooded4PoiTileEntity from "../entities/poi/QuarryFlooded4PoiTileEntity";
import SpringSacred1PoiTileEntity from "../entities/poi/SpringSacred1PoiTileEntity";
import StorageAbandoned1PoiTileEntity from "../entities/poi/StorageAbandoned1PoiTileEntity";
import StorageAbandoned2PoiTileEntity from "../entities/poi/StorageAbandoned2PoiTileEntity";
import SundialForgotten1PoiTileEntity from "../entities/poi/SundialForgotten1PoiTileEntity";
import TerraceGardens1PoiTileEntity from "../entities/poi/TerraceGardens1PoiTileEntity";
import TerraceGardens2PoiTileEntity from "../entities/poi/TerraceGardens2PoiTileEntity";
import TerraceGardens3PoiTileEntity from "../entities/poi/TerraceGardens3PoiTileEntity";
import TerraceGardens4PoiTileEntity from "../entities/poi/TerraceGardens4PoiTileEntity";
import TerraceGardens5PoiTileEntity from "../entities/poi/TerraceGardens5PoiTileEntity";
import TerraceGardens6PoiTileEntity from "../entities/poi/TerraceGardens6PoiTileEntity";
import TerraceGardens7PoiTileEntity from "../entities/poi/TerraceGardens7PoiTileEntity";
import TerraceGardens8PoiTileEntity from "../entities/poi/TerraceGardens8PoiTileEntity";
import TerraceGardens9PoiTileEntity from "../entities/poi/TerraceGardens9PoiTileEntity";
import TreeAncient1PoiTileEntity from "../entities/poi/TreeAncient1PoiTileEntity";
import WatchpostBurned1PoiTileEntity from "../entities/poi/WatchpostBurned1PoiTileEntity";
import Waterfall1PoiTileEntity from "../entities/poi/Waterfall1PoiTileEntity";
import Waterfall2PoiTileEntity from "../entities/poi/Waterfall2PoiTileEntity";
import Whirlpool1PoiTileEntity from "../entities/poi/Whirlpool1PoiTileEntity";
import Whirlpool2PoiTileEntity from "../entities/poi/Whirlpool2PoiTileEntity";
import Whirlpool3PoiTileEntity from "../entities/poi/Whirlpool3PoiTileEntity";
import Whirlpool4PoiTileEntity from "../entities/poi/Whirlpool4PoiTileEntity";
import WitchLake1PoiTileEntity from "../entities/poi/WitchLake1PoiTileEntity";
import type TileEntity from "../entities/TileEntity";
import type TileRepository from "../TileRepository";

const map = new Map<FrameName, typeof TileEntity>();
// Kubo 8
map.set(
	PartlyDemolishedInn1Poi1TileEntity.frameName,
	PartlyDemolishedInn1Poi1TileEntity,
);
map.set(HillGallows1PoiTileEntity.frameName, HillGallows1PoiTileEntity);
map.set(CampSiege1PoiTileEntity.frameName, CampSiege1PoiTileEntity);
map.set(CampSiege2PoiTileEntity.frameName, CampSiege2PoiTileEntity);
map.set(CampSiege3PoiTileEntity.frameName, CampSiege3PoiTileEntity);
map.set(CampSiege4PoiTileEntity.frameName, CampSiege4PoiTileEntity);
map.set(
	MonasteryAbandoned1PoiTileEntity.frameName,
	MonasteryAbandoned1PoiTileEntity,
);
map.set(
	MonasteryAbandoned2PoiTileEntity.frameName,
	MonasteryAbandoned2PoiTileEntity,
);
map.set(
	MonasteryAbandoned3PoiTileEntity.frameName,
	MonasteryAbandoned3PoiTileEntity,
);
map.set(
	MonasteryAbandoned4PoiTileEntity.frameName,
	MonasteryAbandoned4PoiTileEntity,
);
map.set(
	ForestWhispering1PoiTileEntity.frameName,
	ForestWhispering1PoiTileEntity,
);
map.set(
	ForestWhispering2PoiTileEntity.frameName,
	ForestWhispering2PoiTileEntity,
);
map.set(
	ForestWhispering3PoiTileEntity.frameName,
	ForestWhispering3PoiTileEntity,
);
map.set(
	ForestWhispering4PoiTileEntity.frameName,
	ForestWhispering4PoiTileEntity,
);
map.set(
	ForestWhispering5PoiTileEntity.frameName,
	ForestWhispering5PoiTileEntity,
);
map.set(
	ForestWhispering6PoiTileEntity.frameName,
	ForestWhispering6PoiTileEntity,
);
map.set(
	ForestWhispering7PoiTileEntity.frameName,
	ForestWhispering7PoiTileEntity,
);
map.set(
	ForestWhispering8PoiTileEntity.frameName,
	ForestWhispering8PoiTileEntity,
);
map.set(
	ForestWhispering9PoiTileEntity.frameName,
	ForestWhispering9PoiTileEntity,
);
map.set(Waterfall1PoiTileEntity.frameName, Waterfall1PoiTileEntity);
map.set(Waterfall2PoiTileEntity.frameName, Waterfall2PoiTileEntity);
map.set(SpringSacred1PoiTileEntity.frameName, SpringSacred1PoiTileEntity);
map.set(WatchpostBurned1PoiTileEntity.frameName, WatchpostBurned1PoiTileEntity);
map.set(TreeAncient1PoiTileEntity.frameName, TreeAncient1PoiTileEntity);
map.set(CaravanRuins1PoiTileEntity.frameName, CaravanRuins1PoiTileEntity);
map.set(CaravanRuins2PoiTileEntity.frameName, CaravanRuins2PoiTileEntity);
map.set(CryptNoble1PoiTileEntity.frameName, CryptNoble1PoiTileEntity);
map.set(CryptNoble2PoiTileEntity.frameName, CryptNoble2PoiTileEntity);
map.set(
	StorageAbandoned1PoiTileEntity.frameName,
	StorageAbandoned1PoiTileEntity,
);
map.set(
	StorageAbandoned2PoiTileEntity.frameName,
	StorageAbandoned2PoiTileEntity,
);
map.set(CaveShadows1PoiTileEntity.frameName, CaveShadows1PoiTileEntity);
map.set(
	SundialForgotten1PoiTileEntity.frameName,
	SundialForgotten1PoiTileEntity,
);
map.set(
	AlchemistAbandoned1PoiTileEntity.frameName,
	AlchemistAbandoned1PoiTileEntity,
);
map.set(
	AlchemistAbandoned2PoiTileEntity.frameName,
	AlchemistAbandoned2PoiTileEntity,
);
map.set(
	AlchemistAbandoned3PoiTileEntity.frameName,
	AlchemistAbandoned3PoiTileEntity,
);
map.set(
	AlchemistAbandoned4PoiTileEntity.frameName,
	AlchemistAbandoned4PoiTileEntity,
);
map.set(FortressSunken1PoiTileEntity.frameName, FortressSunken1PoiTileEntity);
map.set(FortressSunken2PoiTileEntity.frameName, FortressSunken2PoiTileEntity);
map.set(FortressSunken3PoiTileEntity.frameName, FortressSunken3PoiTileEntity);
map.set(FortressSunken4PoiTileEntity.frameName, FortressSunken4PoiTileEntity);
map.set(QuarryFlooded1PoiTileEntity.frameName, QuarryFlooded1PoiTileEntity);
map.set(QuarryFlooded2PoiTileEntity.frameName, QuarryFlooded2PoiTileEntity);
map.set(QuarryFlooded3PoiTileEntity.frameName, QuarryFlooded3PoiTileEntity);
map.set(QuarryFlooded4PoiTileEntity.frameName, QuarryFlooded4PoiTileEntity);
map.set(
	MonumentMegalithic1PoiTileEntity.frameName,
	MonumentMegalithic1PoiTileEntity,
);
map.set(
	MonumentMegalithic2PoiTileEntity.frameName,
	MonumentMegalithic2PoiTileEntity,
);
map.set(
	MonumentMegalithic3PoiTileEntity.frameName,
	MonumentMegalithic3PoiTileEntity,
);
map.set(
	MonumentMegalithic4PoiTileEntity.frameName,
	MonumentMegalithic4PoiTileEntity,
);
map.set(Whirlpool1PoiTileEntity.frameName, Whirlpool1PoiTileEntity);
map.set(Whirlpool2PoiTileEntity.frameName, Whirlpool2PoiTileEntity);
map.set(Whirlpool3PoiTileEntity.frameName, Whirlpool3PoiTileEntity);
map.set(Whirlpool4PoiTileEntity.frameName, Whirlpool4PoiTileEntity);
map.set(CastawayIsland1PoiTileEntity.frameName, CastawayIsland1PoiTileEntity);
map.set(OutpostSea1PoiTileEntity.frameName, OutpostSea1PoiTileEntity);
map.set(OutpostSea2PoiTileEntity.frameName, OutpostSea2PoiTileEntity);
map.set(OutpostSea3PoiTileEntity.frameName, OutpostSea3PoiTileEntity);
map.set(OutpostSea4PoiTileEntity.frameName, OutpostSea4PoiTileEntity);
map.set(KeepDeserted1PoiTileEntity.frameName, KeepDeserted1PoiTileEntity);
map.set(KeepDeserted2PoiTileEntity.frameName, KeepDeserted2PoiTileEntity);
map.set(KeepDeserted3PoiTileEntity.frameName, KeepDeserted3PoiTileEntity);
map.set(KeepDeserted4PoiTileEntity.frameName, KeepDeserted4PoiTileEntity);
map.set(MobyDick1PoiTileEntity.frameName, MobyDick1PoiTileEntity);
map.set(MobyDick2PoiTileEntity.frameName, MobyDick2PoiTileEntity);
map.set(MobyDick3PoiTileEntity.frameName, MobyDick3PoiTileEntity);
map.set(MobyDick4PoiTileEntity.frameName, MobyDick4PoiTileEntity);
map.set(BigMushroom1PoiTileEntity.frameName, BigMushroom1PoiTileEntity);
map.set(BigMushroom2PoiTileEntity.frameName, BigMushroom2PoiTileEntity);
map.set(BigMushroom3PoiTileEntity.frameName, BigMushroom3PoiTileEntity);
map.set(BigMushroom4PoiTileEntity.frameName, BigMushroom4PoiTileEntity);
map.set(
	AssassinsHideout1PoiTileEntity.frameName,
	AssassinsHideout1PoiTileEntity,
);
map.set(
	AssassinsHideout2PoiTileEntity.frameName,
	AssassinsHideout2PoiTileEntity,
);
map.set(
	AssassinsHideout3PoiTileEntity.frameName,
	AssassinsHideout3PoiTileEntity,
);
map.set(
	AssassinsHideout4PoiTileEntity.frameName,
	AssassinsHideout4PoiTileEntity,
);
map.set(PiratesHideout1PoiTileEntity.frameName, PiratesHideout1PoiTileEntity);
map.set(PiratesHideout2PoiTileEntity.frameName, PiratesHideout2PoiTileEntity);
map.set(PiratesHideout3PoiTileEntity.frameName, PiratesHideout3PoiTileEntity);
map.set(PiratesHideout4PoiTileEntity.frameName, PiratesHideout4PoiTileEntity);
map.set(PiratesHideout5PoiTileEntity.frameName, PiratesHideout5PoiTileEntity);
map.set(PiratesHideout6PoiTileEntity.frameName, PiratesHideout6PoiTileEntity);
map.set(PiratesHideout7PoiTileEntity.frameName, PiratesHideout7PoiTileEntity);
map.set(PiratesHideout8PoiTileEntity.frameName, PiratesHideout8PoiTileEntity);
map.set(PiratesHideout9PoiTileEntity.frameName, PiratesHideout9PoiTileEntity);
map.set(
	AstronomerHideout1PoiTileEntity.frameName,
	AstronomerHideout1PoiTileEntity,
);
map.set(
	AstronomerHideout2PoiTileEntity.frameName,
	AstronomerHideout2PoiTileEntity,
);
map.set(
	AstronomerHideout3PoiTileEntity.frameName,
	AstronomerHideout3PoiTileEntity,
);
map.set(
	AstronomerHideout4PoiTileEntity.frameName,
	AstronomerHideout4PoiTileEntity,
);
map.set(MountainLake1PoiTileEntity.frameName, MountainLake1PoiTileEntity);
map.set(MountainLake2PoiTileEntity.frameName, MountainLake2PoiTileEntity);
map.set(MountainLake3PoiTileEntity.frameName, MountainLake3PoiTileEntity);
map.set(MountainLake4PoiTileEntity.frameName, MountainLake4PoiTileEntity);
map.set(Atol1PoiTileEntity.frameName, Atol1PoiTileEntity);
map.set(Atol2PoiTileEntity.frameName, Atol2PoiTileEntity);
map.set(Atol3PoiTileEntity.frameName, Atol3PoiTileEntity);
map.set(Atol4PoiTileEntity.frameName, Atol4PoiTileEntity);
map.set(Atol5PoiTileEntity.frameName, Atol5PoiTileEntity);
map.set(Atol6PoiTileEntity.frameName, Atol6PoiTileEntity);
map.set(Atol7PoiTileEntity.frameName, Atol7PoiTileEntity);
map.set(Atol8PoiTileEntity.frameName, Atol8PoiTileEntity);
map.set(Atol9PoiTileEntity.frameName, Atol9PoiTileEntity);
map.set(BearSkeleton1PoiTileEntity.frameName, BearSkeleton1PoiTileEntity);
map.set(Crater1PoiTileEntity.frameName, Crater1PoiTileEntity);
map.set(Crater2PoiTileEntity.frameName, Crater2PoiTileEntity);
map.set(Crater3PoiTileEntity.frameName, Crater3PoiTileEntity);
map.set(Crater4PoiTileEntity.frameName, Crater4PoiTileEntity);
map.set(PlaguedForest1PoiTileEntity.frameName, PlaguedForest1PoiTileEntity);
map.set(PlaguedForest2PoiTileEntity.frameName, PlaguedForest2PoiTileEntity);
map.set(PlaguedForest3PoiTileEntity.frameName, PlaguedForest3PoiTileEntity);
map.set(PlaguedForest4PoiTileEntity.frameName, PlaguedForest4PoiTileEntity);
map.set(Menhir1PoiTileEntity.frameName, Menhir1PoiTileEntity);
map.set(Menhir2PoiTileEntity.frameName, Menhir2PoiTileEntity);
map.set(FalconersTower1PoiTileEntity.frameName, FalconersTower1PoiTileEntity);
map.set(FalconersTower2PoiTileEntity.frameName, FalconersTower2PoiTileEntity);
map.set(TerraceGardens1PoiTileEntity.frameName, TerraceGardens1PoiTileEntity);
map.set(TerraceGardens2PoiTileEntity.frameName, TerraceGardens2PoiTileEntity);
map.set(TerraceGardens3PoiTileEntity.frameName, TerraceGardens3PoiTileEntity);
map.set(TerraceGardens4PoiTileEntity.frameName, TerraceGardens4PoiTileEntity);
map.set(TerraceGardens5PoiTileEntity.frameName, TerraceGardens5PoiTileEntity);
map.set(TerraceGardens6PoiTileEntity.frameName, TerraceGardens6PoiTileEntity);
map.set(TerraceGardens7PoiTileEntity.frameName, TerraceGardens7PoiTileEntity);
map.set(TerraceGardens8PoiTileEntity.frameName, TerraceGardens8PoiTileEntity);
map.set(TerraceGardens9PoiTileEntity.frameName, TerraceGardens9PoiTileEntity);
map.set(Kraken1PoiTileEntity.frameName, Kraken1PoiTileEntity);
map.set(Kraken2PoiTileEntity.frameName, Kraken2PoiTileEntity);
map.set(Kraken3PoiTileEntity.frameName, Kraken3PoiTileEntity);
map.set(Kraken4PoiTileEntity.frameName, Kraken4PoiTileEntity);
map.set(WitchLake1PoiTileEntity.frameName, WitchLake1PoiTileEntity);
map.set(Geyser1PoiTileEntity.frameName, Geyser1PoiTileEntity);
map.set(Geyser2PoiTileEntity.frameName, Geyser2PoiTileEntity);
map.set(Geyser3PoiTileEntity.frameName, Geyser3PoiTileEntity);
map.set(Geyser4PoiTileEntity.frameName, Geyser4PoiTileEntity);

// TODO: rename + rename file
export const getPoiTileEntity = (type: FrameName): typeof TileEntity | null =>
	map.has(type) ? map.get(type)! : null;

// TODO: rename + rename file
export const createPoiTileEntity = (
	type: FrameName,
	coordinates: TileCoordinates,
	tilerepo: TileRepository,
): TileEntity | null => {
	const entity = getPoiTileEntity(type);
	return entity ? new entity(coordinates, tilerepo) : null;
};
